
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1em","height":"1em","viewBox":"0 0 20 20","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M18.625 2.313h-3.938v-1.5A.188.188 0 0014.5.625h-1.313A.188.188 0 0013 .813v1.5H7v-1.5a.188.188 0 00-.188-.188H5.5a.188.188 0 00-.188.188v1.5H1.376a.75.75 0 00-.75.75v15.562c0 .415.335.75.75.75h17.25a.75.75 0 00.75-.75V3.062a.75.75 0 00-.75-.75zm-.938 6.468v8.906H2.313V8.781h15.376zM2.313 7.187V4h3v1.125c0 .103.085.188.188.188h1.313A.188.188 0 007 5.125V4h6v1.125c0 .103.084.188.188.188H14.5a.188.188 0 00.188-.188V4h3v3.188H2.313zm9.149 4.57h-.367a.249.249 0 00-.202.105l-1.228 1.703-.556-.772a.25.25 0 00-.203-.104H8.54c-.05 0-.08.058-.05.1l.973 1.35a.249.249 0 00.403 0l1.646-2.282c.03-.041 0-.1-.05-.1zM6.5 13a3.5 3.5 0 117 0 3.5 3.5 0 01-7 0zm.594 0a2.907 2.907 0 105.813-.001A2.907 2.907 0 007.094 13z"}})])
          )
        }
      }
    